import React from "react"
import { Row, Col, Container } from "react-bootstrap"

const ForUs = () => {
  return (
    <section id="for-us">
      <Container>
        <div className="row justify-content-center">
          <Col md={8} className="text-center">
            <h1>
              For us to accomplish this mission, Rehab Find has outlined key
              strategies that guide what we aim for
            </h1>
          </Col>
        </div>
      </Container>
    </section>
  )
}

export default ForUs
